export const COPY = {
  header: "Great! You're all done!",
  body: "You can continue to use the below calculator to continue to investigate how much you'd pay if you took finance with Ideal4Finance",
};
